/* jshint esversion: 6 */
/* jshint ignore:start */
import axios from 'axios';
import { useContext, useEffect } from 'react';
import { MyContext } from '../Context/MyProvider';
import { useNavigate } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';

const PaytmPayment = ({ Amount }) => {

    const { paymentBaseURL, setPaymentLoading, setPaymentRes } = useContext(MyContext);

    const navigate = useNavigate();

    useEffect(() => {

        secureLocalStorage.setItem("Amount", Amount);

        const Userid = secureLocalStorage.getItem("Userid");

        if (!Amount && !Userid) return;

        axios.post(`${paymentBaseURL}react_paytm/index.php`, {
            "amt": Amount,
            "uid": Userid
        })
            .then((res) => {
                if (res.data.Result === "true") {
                    makePayment(res.data);
                    setPaymentLoading(false);
                }
            });

    }, [Amount, paymentBaseURL]);

    const makePayment = (Data) => {

        var config = {
            "root": "",
            "style": {
                "bodyBackgroundColor": "#fafafb",
                "themeBackgroundColor": "#0FB8C9",
                "themeColor": "#ffffff",
                "headerBackgroundColor": "#284055",
                "headerColor": "#ffffff",
            },
            "data": {
                "orderId": Data.order_id,
                "token": Data.txnToken,
                "tokenType": "TXN_TOKEN",
                "amount": Data.amount
            },
            "payMode": {
                "order": ["CC", "DC", "NB", "UPI", "PPBL", "PPI", "BALANCE"]
            },
            "website": "WEBSTAGING",
            "flow": "DEFAULT",
            "merchant": {
                "mid": Data.mid,
                "redirect": false
            },
            "handler": {
                "transactionStatus": function (paymentStatus) {
                    sessionStorage.setItem("transactionid", paymentStatus.BANKTXNID);
                    setPaymentRes("PaymentDone");
                    setTimeout(() => {
                        navigate(0);
                    }, 500);
                },
                "notifyMerchant": function (eventName, data) {

                }
            }
        };

        if (window.Paytm && window.Paytm.CheckoutJS) {
            window.Paytm.CheckoutJS.init(config)
                .then(function onSuccess() {
                    window.Paytm.CheckoutJS.invoke();
                });
        }

    };

    return null;
};

export default PaytmPayment;
/* jshint ignore:end */